import React, { Component } from 'react';

class Cookies extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <div id="Cookies">
                <p><b>Cookies</b></p>
                <p>In order to ensure the proper functioning of this website, we sometimes store small data files, cookie. This is a common practice for most websites.
                </p>
                <br />
                <p><b>What are cookies?</b></p>
                <p>A cookie is a small text file that a website saves on your computer or mobile device when you browse it. With this file, the website keeps track of your steps and preferences (such as login, language, font size, and other display settings) for a period of time, so you don't have to re-list them when you next visit the site or browse its pages.</p>
                <br />
                <p><b>How do we use cookies?</b></p>
                <p>These websites use cookies to remember user settings, to better tailor ads to the interests of visitors, and to the necessary functionality of the website.</p>
                <br />
                <p><b>How to control cookies</b></p>
                <p>You can check or delete cookies at your discretion - see aboutcookies.org for details. You can clear all cookies stored on your computer and set most browsers to prevent them from being stored. However, in this case, you may need to manually adjust some settings each time you visit a website, and some services and features may not work.</p>
                <br />
                <p><b>How to decline cookies</b></p>
                <p>Cookies can be set up in settings of your Internet browser. Most browsers automatically accept cookies by default.</p>
            </div>
        )
    }
}

export default Cookies;


// WEBPACK FOOTER //
// ./src/components/Cookies.jsx